import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import "../../Common/Lib/react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from '../../Common/Lib/react-responsive-carousel';
import {Blogs } from "../../data"


class RCarousel extends Component {
    render() {
        return (
            <Carousel interval={4000} transitionTime={800} autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false} showThumbs={false} animationHandler="fade" swipeable={false}>
                <div>
                    <img src={Blogs.BlogHeader} className="car-image"
                    alt="Webuildd Blog"  /> 
                    {/* <p className="legend">Legend 1</p> */}
                </div>
                <div>
                    <img src={Blogs.BlogHeader} className="car-image" alt="Webuildd Blog"/>
                    {/* <p className="legend">Legend 2</p> */}
                </div>
                <div>
                    <img src={Blogs.BlogHeader} className="car-image" alt="Webuildd Blog"/>
                    {/* <p className="legend">Legend 3</p> */}
                </div>
            </Carousel>
        );
    }
}

export default RCarousel;